// extracted by mini-css-extract-plugin
export default {"correspondenceList":"styles_correspondenceList__Q+PNH","FooterStyle":"styles_FooterStyle__6vq6O"};